export default [
  {
    path: '/h5/rank-list-rule',
    component: () => import('./Page.vue'),
    meta: {
      title: '排行榜规则',
    },
  },
]
